:host {
    display: block;

    .panels {
        background-color: $color-grey-05-light;
        border-bottom: 4px solid $color-red;
    }

    .panel-grid {
        @include grid;
    }

    .panel-wrapper {
        grid-column: 2 / -2;
        position: relative;
        display: grid;
        grid-auto-columns: 1fr;
        grid-auto-flow: column;
        justify-items: center;
        column-gap: var(--column-gap);
        padding: 60px 0 36px;
    }

    .panel {
        border: 0;
        background-color: transparent;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        text-align: center;
        transition: color 300ms;
        cursor: pointer;

        h2 {
            @include typo-ws-h4;

            margin: 20px 0 12px;
        }

        &::before {
            content: ' ';
            background-color: $color-grey-06-bright;
            border-top: 4px solid $color-red;
            border-left: 4px solid $color-red;
            bottom: 0;
            position: absolute;
            width: 20px;
            height: 20px;
            transform: translate(0, 53%) rotate(45deg);
            opacity: 0;
            transition: opacity 0.1s 0s;
        }

        &:hover {
            color: $color-red;

            .arrow-svg {
                transform: translate3d(0, 8px, 0);

                /* stylelint-disable-next-line selector-max-compound-selectors, max-nesting-depth */
                .shaft {
                    opacity: 1;
                }
            }
        }

        &.active {
            .arrow-svg {
                transition: none;
                opacity: 0;
            }

            &::before {
                opacity: 1;
                transition: opacity 0.1s 0.6s;
            }
        }
    }

    .service-svg {
        align-self: center;
        display: block;
        width: 96px;
        color: $color-red;
    }

    .arrow-svg {
        color: $color-red;
        transition:
            opacity 300ms,
            transform 300ms;
        margin-top: auto;

        .shaft {
            opacity: 0;
        }
    }

    .inactive {
        color: $color-grey-03;

        .arrow-svg,
        sew-icon {
            color: inherit;
        }
    }
}

:host(.spacing) {
    @include component-spacing;
}

@include mq-1 {
    :host {
        .panels {
            display: none;
        }
    }
}
